import React from 'react';
import PropTypes from 'prop-types';
import classNames from './classNames.js';

var cx = classNames('Hits');

var Hits = function Hits(_ref) {
  var hits = _ref.hits,
      HitComponent = _ref.hitComponent;
  return (
    // Spread the hit on HitComponent instead of passing the full object. BC.
    // ex: <HitComponent {...hit} key={hit.objectID} />
    React.createElement(
      'div',
      cx('root'),
      hits.map(function (hit) {
        return React.createElement(HitComponent, { key: hit.objectID, hit: hit });
      })
    )
  );
};

Hits.propTypes = {
  hits: PropTypes.array,
  hitComponent: PropTypes.func.isRequired
};

Hits.defaultProps = {
  hitComponent: function hitComponent(props) {
    return React.createElement(
      'div',
      {
        style: {
          borderBottom: '1px solid #bbb',
          paddingBottom: '5px',
          marginBottom: '5px'
        }
      },
      JSON.stringify(props).slice(0, 100),
      '...'
    );
  }
};

export default Hits;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch/es/src/components/Hits.js
// module id = ../../node_modules/react-instantsearch/es/src/components/Hits.js
// module chunks = 6